export const DEFAULT_PRIMARY_COLOR = '#01026b';
export const DEFAULT_SECONDARY_COLOR = '#66a0fe';
// Fallback colors used when rendering an imported report table that has no
// saved customization. These are document/print colors (data, not app UI),
// so they live here rather than as design tokens.
export const DEFAULT_TABLE_PRIMARY_COLOR = '#0a2a8a';
export const DEFAULT_TABLE_HEADER_COLOR = '#e6e7e8';
export const EMPTY_VALUE = '-';
export const LOADING_MESSAGE = 'Carregando...';

// Finalidade do laudo (CFP 06/2019 §2º IV). O limite existe por dois motivos:
// espelha o `max(500)` do schema da API e impede que o texto livre estique a
// tabela de identificação a ponto de comer a primeira página.
export const REPORT_FINALIDADE_MAX_LENGTH = 500;

// Referência de um instrumento livre. Espelha o `max(500)` do
// `tableBlockSchema` da API — o texto vira nota de rodapé, e uma citação maior
// que isso deixa de caber no pé da página.
export const FREE_INSTRUMENT_REFERENCE_MAX_LENGTH = 500;

// Legenda que um instrumento livre carrega até a pessoa nomeá-lo. Fica aqui
// porque as duas rotas que criam um (o formulário e a colagem) montam os blocos
// em arquivos diferentes, e a lista da bateria precisa do mesmo rótulo nas duas.
export const FREE_INSTRUMENT_LABEL = 'Novo instrumento';

export const DEFAULT_FONT = 'Georgia, serif';
export const APP_FONT =
    'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';

export const ONE_MINUTE = 60000;

export const A4_PAGE_HEIGHT = 1123;
export const A4_PAGE_WIDTH = 794;

export const BRAZILIAN_STATES = [
    'AC',
    'AL',
    'AP',
    'AM',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MT',
    'MS',
    'MG',
    'PA',
    'PB',
    'PR',
    'PE',
    'PI',
    'RJ',
    'RN',
    'RS',
    'RO',
    'RR',
    'SC',
    'SP',
    'SE',
    'TO',
];
